// extracted by mini-css-extract-plugin
export default {"box":"MenuModal_box__X8W6D","zoom":"MenuModal_zoom__8j7es"};